import React, { Component } from 'react';
import { i18n } from '../data/i18n.js';
import LoginFormBase from '../components/LoginFormBase';
import { withFirebase } from '../auth/firebase/context';

export default class Login extends Component {
    render() {

        const LoginForm = withFirebase(LoginFormBase);
        
        return(
            <>
                <LoginForm />
            </>
        );
    }
}